import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import localsearchLogo from '../../assets/branding/localsearch-logo.jpg';
import config from '../../../src/client/config';

const { urlRoot } = config;

const Meta = ({ canonical, category }) => {
  const title = useMemo(() => {
    if (category === 'Plumbers')
      return `Looking for the best ${category} in Australia? | Localsearch`;
    return `Looking for ${category} near you? | Localsearch`;
  }, [category]);
  const description = `Find ${category} near you on Localsearch! Read reviews, top-rated ${category}, see photos, get directions and more!`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="COPYRIGHT" content="Localsearch" />
      <meta name="AUTHOR" content="Localsearch" />
      <meta name="RESOURCE-TYPE" content="DOCUMENT" />
      <meta name="DISTRIBUTION" content="GLOBAL" />
      <meta name="RATING" content="GENERAL" />
      <meta property="og:title" content={title} />
      <meta property="og:type" content="company" />
      <meta property="og:image" content={`${urlRoot}/${localsearchLogo}`} />
      <meta property="og:url" content={urlRoot} />
      <meta property="og:site_name" content="Localsearch" />
      <meta property="og:description" content={description} />
      <link rel="canonical" href={`${urlRoot}${canonical}`} />
    </Helmet>
  );
};

Meta.propTypes = {
  category: PropTypes.string,
  canonical: PropTypes.string,
};

Meta.defaultProps = {
  category: '',
  canonical: '',
};

export default Meta;
